"use client";

import Image from "next/image";
import Container from "@/components/ui/Container";

export default function IntermediateCTA() {
  return (
    <section
      className="pt-10 md:pt-12 lg:pt-20 pb-10 md:pb-12 lg:pb-0"
      style={{
        background:
          "url('/images/Bloom-Wise_CTA_mockup_background.webp') lightgray 50% / cover no-repeat",
      }}
    >
      <Container>
        <div className="flex flex-col justify-center items-center  lg:gap-0">
          <div className="w-full max-w-4xl md:max-w-5xl lg:max-w-full mx-auto px-6 md:px-26 lg:px-0">
            <div className="grid lg:grid-cols-3 gap-6 lg:gap-8 items-center">
              {/* Column 1: Title */}
              <div className="flex items-center justify-center lg:justify-start order-2 lg:order-1">
                <h2
                  className="text-center lg:text-left text-[32px] lg:text-[40px] leading-[40px] lg:leading-[50px]"
                  style={{
                    flex: "1 0 0",
                    color: "#242424",
                    fontWeight: 400,
                  }}
                >
                  Experimente el futuro de la agricultura con BloomWise
                </h2>
              </div>

              {/* Column 2: Image */}
              <div
                className="relative order-1 lg:order-2 md:w-[350px] md:mx-auto lg:w-auto lg:mx-0"
                style={{
                  background:
                    "url('/images/Bloom-Wise_CTA_mockup-mobile.webp') center / contain no-repeat",
                  height: "450px",
                  flex: "1 0 0",
                }}
              ></div>

              {/* Column 3: Text + App Store Badges */}
              <div className="flex flex-col justify-center items-center lg:items-start order-3">
                <p
                  className="mb-6 text-center lg:text-left text-[16px] lg:text-[18px] leading-[24px] lg:leading-[28px]"
                  style={{
                    color: "#242424",
                    fontWeight: 400,
                  }}
                >
                  Con BloomWise, los agricultores pueden mejorar la eficiencia y
                  la precisión del muestreo, tomar decisiones más informadas y
                  lograr cultivos más saludables y rentables.
                </p>

                {/* App Store Badges */}
                <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
                  <a href="#" className="hover:opacity-80 transition-opacity">
                    <Image
                      src="/images/google_play_button_green.svg"
                      alt="Disponible en Google Play"
                      width={175}
                      height={57}
                      className="w-[175px] h-[57px] object-contain"
                    />
                  </a>
                  <a href="#" className="hover:opacity-80 transition-opacity">
                    <Image
                      src="/images/apple_store_button_green.svg"
                      alt="Disponible en App Store"
                      width={175}
                      height={57}
                      className="w-[175px] h-[57px] object-contain"
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </section>
  );
}
